import type { BodyMeasurementFieldKey } from '../../types/bodyMeasurements';

export const BODY_MEASUREMENTS_BASE_PATH = '/enviar-medidas';

export const BODY_MEASUREMENT_FIELDS: {
  key: BodyMeasurementFieldKey;
  label: string;
  unit: string;
  placeholder: string;
}[] = [
  { key: 'weightKg', label: 'Peso', unit: 'kg', placeholder: '0,00' },
  { key: 'waistCm', label: 'Cintura', unit: 'cm', placeholder: '0,0' },
  { key: 'abdomenCm', label: 'Abdômen', unit: 'cm', placeholder: '0,0' },
  { key: 'hipCm', label: 'Quadril', unit: 'cm', placeholder: '0,0' },
  { key: 'neckCm', label: 'Pescoço', unit: 'cm', placeholder: '0,0' },
];
